export default "__VITE_ASSET__yA89Fqj1__"